const DEFAULT_TIMEZONE = 'Africa/Accra'

const AGENCY_TIMEZONES = {
  STRANSITGHA: 'Africa/Accra',
  GPRTU: 'Africa/Accra',
  PROTOA: 'Africa/Accra'
}

function getTimezoneByAgencyId (agencyId) {
  const normalizedAgencyId = String(agencyId || '').trim().toUpperCase()
  return AGENCY_TIMEZONES[normalizedAgencyId] || DEFAULT_TIMEZONE
}

module.exports = {
  DEFAULT_TIMEZONE,
  AGENCY_TIMEZONES,
  getTimezoneByAgencyId
}
